


export type EmploymentType = 'Fixed' | 'Temporary';

export const EmploymentType = {
    Fixed: 'Fixed' as EmploymentType,
    Temporary: 'Temporary' as EmploymentType
};

